


  
  

  var faOriginalBeginner = {
    prefix: 'fak',
    iconName: 'original-beginner',
    icon: [
      512,
      512,
      [],
      'e003',
      
      'M275.2 505.6l160-105.6c9.6-6.4 12.8-16 12.8-25.6V32c0-22.4-22.4-38.4-44.8-28.8L256 67.2 108.8 0C86.4-9.6 64 6.4 64 28.8v342.4c0 9.6 6.4 19.2 12.8 25.6l160 105.6c9.6 6.4 25.6 6.4 35.2 0zM128 355.2V80l96 41.6v297.6l-96-64z'
      
    ]
  };

  

  
  

  var faOriginalGradio = {
    prefix: 'fak',
    iconName: 'original-gradio',
    icon: [
      640,
      512,
      [],
      'e008',
      
      'M104 188.7L319.8 64.1l.1-.1c0 0 .1 0 .1 0c0 0 .1 0 .1 0l.1 .1L535.8 188.7l-.2 .3 .2 0 0 48-33 19 33 19-.2 .3 .2 0 0 48L320.1 447.9l-.1 .1c0 0-.1 0-.1 0c0 0-.1 0-.1 0l-.1-.1L104 323.3l.2-.3-.2 0 0-48 33-19-33-19 .2-.3-.2 0 0-48zm54.1 24.1l26.8 15.5 134.8-77.8 .1-.1c0 0 .1 0 .1 0c0 0 .1 0 .1 0l.1 .1 134.8 77.8 26.8-15.5L319.9 119.4 158.1 212.8zM406.9 256l-87-50.2-87 50.2 87 50.2 87-50.2zM320.1 361.5l-.1 .1c0 0-.1 0-.1 0c0 0-.1 0-.1 0l-.1-.1L184.9 283.7l-26.8 15.5 161.8 93.4 161.8-93.4-26.8-15.5L320.1 361.5z'
      
    ]
  };

  

  
  

  var faOriginalLama = {
    prefix: 'fak',
    iconName: 'original-lama',
    icon: [
      640,
      512,
      [],
      'e007',
      
      'M503.6 66.3c-3.4-14.3 10.2-59 1.7-64.4s-27.2 35.8-27.2 35.8H444.4C439.3 12.7 427-1.6 420.2 .2c-6.8 1.8-1.7 44.7 0 50.1c1.7 5.4-8.5 39.3-11.9 57.2c-3.4 17.9 6.8 23.2 6.8 46.5s-1.7 41.8-15.3 57.9c-25.8 30.5-112.5-1-173.7 10.7c-52.8 0-88.6 32.2-97.1 85.8c-5.6 35.5 14.3 38.6 23.2 28.5c.2 9.4 1.1 18 2.3 25.1c6.8 39.3 23.4 124 23.4 124c2.4 14.5 14.4 25.1 28.3 25.9c15.4-.7 27.9-13.6 28.6-30l3.2-84.1H364l2.1 88.3c.2 14.3 11.2 25.8 24.8 26c11.6-.2 21.6-8.7 24.2-20.6l25.5-109.7c61.3-57.9 61.3-136.6 61.3-184.8c0 0-1.7-16.1 1.7-44.7c17-30.4 3.4-71.5 0-85.8z'
      
    ]
  };

  

  
  

  var faOriginalPhotoshop = {
    prefix: 'fak',
    iconName: 'original-photoshop',
    icon: [
      512,
      512,
      [],
      'e002',
      
      'M416 480H96c-35.2 0-64-28.8-64-64V96c0-35.2 28.8-64 64-64h320c35.2 0 64 28.8 64 64v320c0 35.2-28.8 64-64 64zM137.6 339.2h44.8v-70.4c3.2 0 9.6 0 16 0c25.6 0 48-6.4 64-19.2c12.8-9.6 19.2-25.6 19.2-44.8s-9.6-35.2-19.2-44.8c-12.8-9.6-32-16-60.8-16s-44.8 0-60.8 3.2v192zm41.6-160s9.6 0 19.2 0c22.4 0 35.2 9.6 35.2 28.8s-16 32-38.4 32-9.6 0-16 0v-57.6zm99.2 153.6c9.6 6.4 25.6 9.6 44.8 9.6c41.6 0 60.8-19.2 60.8-44.8c0-19.2-12.8-35.2-38.4-44.8c-16-6.4-22.4-9.6-22.4-16s6.4-12.8 16-12.8 25.6 3.2 32 9.6l6.4-28.8c-9.6-3.2-22.4-9.6-38.4-9.6c-35.2 0-57.6 19.2-57.6 44.8c0 16 9.6 32 41.6 41.6c16 6.4 19.2 9.6 19.2 16s-6.4 12.8-19.2 12.8-28.8-6.4-38.4-9.6l-6.4 32z'
      
    ]
  };

  



export {

  faOriginalBeginner,
  

  faOriginalGradio,
  

  faOriginalLama,
  

  faOriginalPhotoshop,
  

};
